import { isOpsSupervisor, isTentSlot } from "./scheduleRoleUtils";

export const MEDICAL_HQ_BASE_ROW_DEFS = [
  { roleKey: "Triage Supervisor", roleLabel: "Triage Supervisor", displayLabel: "Triage Supervisor" },

  { roleKey: "Physician__1", roleLabel: "Physician", displayLabel: "Physician 1" },
  { roleKey: "Physician__2", roleLabel: "Physician", displayLabel: "Physician 2" },

  { roleKey: "APRN/PA__1", roleLabel: "APRN/PA", displayLabel: "APRN/PA 1" },
  { roleKey: "APRN/PA__2", roleLabel: "APRN/PA", displayLabel: "APRN/PA 2" },

  { roleKey: "RN__1", roleLabel: "RN", displayLabel: "RN 1" },
  { roleKey: "RN__2", roleLabel: "RN", displayLabel: "RN 2" },

  { roleKey: "Paramedic__1", roleLabel: "Paramedic", displayLabel: "Paramedic 1" },
  { roleKey: "Paramedic__2", roleLabel: "Paramedic", displayLabel: "Paramedic 2" },
  { roleKey: "Paramedic__3", roleLabel: "Paramedic", displayLabel: "Paramedic 3" },

  { roleKey: "EMT/AEMT__1", roleLabel: "EMT/AEMT", displayLabel: "EMT/AEMT 1" },
  { roleKey: "EMT/AEMT__2", roleLabel: "EMT/AEMT", displayLabel: "EMT/AEMT 2" },
  { roleKey: "EMT/AEMT__3", roleLabel: "EMT/AEMT", displayLabel: "EMT/AEMT 3" },

  { roleKey: "Tech", roleLabel: "Tech", displayLabel: "Tech" },
  { roleKey: "Transport", roleLabel: "Transport", displayLabel: "Transport" },

  { roleKey: "Ambulance (ALS)__1", roleLabel: "Ambulance", displayLabel: "Ambulance 1" },
  { roleKey: "Ambulance (ALS)__2", roleLabel: "Ambulance", displayLabel: "Ambulance 2" },
];

export const MEDICAL_HQ_BASE_ROWS = MEDICAL_HQ_BASE_ROW_DEFS.map((x) => x.roleKey);

export const MEDICAL_HQ_BASE_ORDER = {
  "Triage Supervisor": 100,

  "Physician__1": 200,
  "Physician__2": 210,

  "APRN/PA__1": 300,
  "APRN/PA__2": 310,

  "RN__1": 400,
  "RN__2": 410,

  "Paramedic__1": 500,
  "Paramedic__2": 510,
  "Paramedic__3": 520,

  "EMT/AEMT__1": 600,
  "EMT/AEMT__2": 610,
  "EMT/AEMT__3": 620,

  Tech: 700,
  Transport: 800,

  "Ambulance (ALS)__1": 900,
  "Ambulance (ALS)__2": 910,
};

export const COMMAND_TEAM_BASE_ROWS = [
  "Incident Command",
  "Unified Command",
  "Planning",
  "Logistics",
  "Ops Manager",
];

export const COMMAND_TEAM_BASE_ORDER = {
  "Incident Command": 100,
  "Unified Command": 200,
  Planning: 300,
  Logistics: 400,
  "Ops Manager": 500,
};

export const DISPATCH_BASE_ROWS = ["Dispatcher", "Dispatcher 2"];

export const DISPATCH_BASE_ORDER = {
  Dispatcher: 100,
  "Dispatcher 2": 200,
};

export const FRONT_9_ASSIGNMENTS = [
  "Ops Supervisor 1",
  "Tent 3",
  "Cart 3",
  "Tent 5",
  "Cart 5",
  "Tent 9",
  "Cart 9",
  "Bike 1",
];

export const BACK_9_ASSIGNMENTS = [
  "Ops Supervisor 2",
  "Tent 12",
  "Cart 12",
  "Cart 15",
  "Tent 17",
  "Cart 17",
  "Bike 2",
  "Bike 3",
];

export function getMedicalHQBaseOrder(roleKey) {
  return MEDICAL_HQ_BASE_ORDER[roleKey] ?? 9999;
}

export function getCommandTeamBaseOrder(roleKey) {
  return COMMAND_TEAM_BASE_ORDER[roleKey] ?? 9999;
}

export function getDispatchBaseOrder(roleKey) {
  return DISPATCH_BASE_ORDER[roleKey] ?? 9999;
}

export function getMedicalHQExtraSortOrder(extra) {
  if (typeof extra?.order === "number" && Number.isFinite(extra.order)) return extra.order;
  return 950;
}

export function getCommandTeamExtraSortOrder(extra) {
  if (typeof extra?.order === "number" && Number.isFinite(extra.order)) return extra.order;
  return 550;
}

export function getDispatchExtraSortOrder(extra) {
  if (typeof extra?.order === "number" && Number.isFinite(extra.order)) return extra.order;
  return 150;
}

export function getInsideExtraSortOrder(extra) {
  if (typeof extra?.order === "number" && Number.isFinite(extra.order)) return extra.order;
  return 150;
}

export function getMedicalHQNextExtraOrder(existingExtras = []) {
  const values = existingExtras
    .map((x) => (typeof x?.order === "number" && Number.isFinite(x.order) ? x.order : null))
    .filter((x) => x != null && x > 910)
    .sort((a, b) => a - b);

  if (values.length === 0) return 950;
  return values[values.length - 1] + 50;
}

export function getCommandTeamNextExtraOrder(existingExtras = []) {
  const values = existingExtras
    .map((x) => (typeof x?.order === "number" && Number.isFinite(x.order) ? x.order : null))
    .filter((x) => x != null && x > 500)
    .sort((a, b) => a - b);

  if (values.length === 0) return 550;
  return values[values.length - 1] + 50;
}

export function getDispatchNextExtraOrder(existingExtras = []) {
  const values = existingExtras
    .map((x) => (typeof x?.order === "number" && Number.isFinite(x.order) ? x.order : null))
    .filter((x) => x != null && x > 100)
    .sort((a, b) => a - b);

  if (values.length === 0) return 150;
  return values[values.length - 1] + 50;
}

export function getNextInsideExtraOrder(existingExtras = []) {
  const values = existingExtras
    .map((x) => (typeof x?.order === "number" && Number.isFinite(x.order) ? x.order : null))
    .filter((x) => x != null)
    .sort((a, b) => a - b);

  if (values.length === 0) return 150;
  return values[values.length - 1] + 50;
}

export function buildReindexedExtraOrders(sequence, baseRows, getBaseOrder) {
  const result = {};
  let i = 0;

  while (i < sequence.length) {
    const key = sequence[i];

    if (baseRows.includes(key)) {
      i += 1;
      continue;
    }

    let prevBaseOrder = 0;
    for (let j = i - 1; j >= 0; j -= 1) {
      if (baseRows.includes(sequence[j])) {
        prevBaseOrder = getBaseOrder(sequence[j]);
        break;
      }
    }

    let nextBaseOrder = null;
    for (let j = i + 1; j < sequence.length; j += 1) {
      if (baseRows.includes(sequence[j])) {
        nextBaseOrder = getBaseOrder(sequence[j]);
        break;
      }
    }

    if (nextBaseOrder == null) {
      nextBaseOrder = prevBaseOrder + 100;
    }

    const groupKeys = [];
    let j = i;
    while (j < sequence.length && !baseRows.includes(sequence[j])) {
      groupKeys.push(sequence[j]);
      j += 1;
    }

    const gap = nextBaseOrder - prevBaseOrder;
    const step = gap / (groupKeys.length + 1);

    groupKeys.forEach((groupKey, index) => {
      result[groupKey] = prevBaseOrder + step * (index + 1);
    });

    i = j;
  }

  return result;
}

export function getInsideAddTargetsForBlock(blockTitle) {
  if (blockTitle === "Front 9") {
    return FRONT_9_ASSIGNMENTS.filter((role) => isTentSlot(role) || isOpsSupervisor(role));
  }

  if (blockTitle === "Back 9") {
    return BACK_9_ASSIGNMENTS.filter((role) => isTentSlot(role) || isOpsSupervisor(role));
  }

  return [];
}